import React from 'react';
import PropTypes from 'prop-types';
import clone from 'clone';

import {OEMediaViewerReadyState} from '../oe-media-viewer-model';
import OEMediaViewerContentController from './oe-media-viewer-content-controller';
import OEPDFView from '../../elements/pdf-view/oe-pdf-view';
import OEToolbox from '../../../lib/tools/oe-toolbox';

export default class OEMediaViewerPDFContentController extends React.PureComponent {

    constructor(props) {
        super(props);

        this.readyState = OEMediaViewerReadyState.noMeta;
        this.contentSize = null;

        this.ref = null;

        this.onRef = this.onRef.bind(this);

        this.onDocumentStateChanged = this.onDocumentStateChanged.bind(this);
        this.onDocumentPageStateChanged = this.onDocumentPageStateChanged.bind(this);
        this.onError = this.onError.bind(this);
    }

    getReadyState() {
        return this.readyState;
    }

    getContentSize()    {
        return this.contentSize;
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.src !== this.props.src)     {
            if(this.readyState !== OEMediaViewerReadyState.noMeta) {
                this.readyState = OEMediaViewerReadyState.noMeta;
                this.props.onReadyStateChanged(this.readyState);
            }
        }
    }

    onRef(ref) {
        if(ref === this.ref)    return;
        this.ref = ref;
    }

    render() {
        return (
            <OEMediaViewerContentController
                className={this.props.className}
                backgroundColor={this.props.backgroundColor}
                contentRect={this.props.contentRect}
            >
                <OEPDFView 
                    fileURL={this.props.src}
                    errorStr=""
                    onDocumentStateChanged={this.onDocumentStateChanged}
                    onDocumentPageStateChanged={this.onDocumentPageStateChanged}
                    onError={this.onError}
                    ref={this.onRef}
                />;
            </OEMediaViewerContentController>
        );
    }

    onDocumentStateChanged(sender, documentState)   {
        if(documentState.loaded && this.readyState !== OEMediaViewerReadyState.ready)   {
            this.readyState = OEMediaViewerReadyState.ready;
            this.props.onReadyStateChanged(this.readyState);
        }
    }

    onDocumentPageStateChanged(sender, pageIndex, documentState, prevDocumentState)   {
        if(!documentState.numPagesLoaded)    return;
        let prevContentSize = this.contentSize;
        this.contentSize = clone(documentState.size);
        this.contentSize.h *= 1.1;
        if(OEToolbox.shallowEqual(this.contentSize, prevContentSize))    return;
        this.props.onContentSizeChanged(this.contentSize);
    }

    onError(sender)   {
        console.log('onError');
        if(this.readyState !== OEMediaViewerReadyState.error)   {
            this.readyState = OEMediaViewerReadyState.error;
            this.props.onReadyStateChanged(this.readyState);
        }
    }
}

OEMediaViewerPDFContentController.defaultProps = {
    className: '',
    onReadyStateChanged: (state) => {},
    onContentSizeChanged: (size) => {}
};

OEMediaViewerPDFContentController.propTypes = {
    className: PropTypes.string,
    onReadyStateChanged: PropTypes.func,
    onContentSizeChanged: PropTypes.func
};